<script>
    import axios from 'axios'
    import * as tables from '../../tables'

    const apiBaseUrl = 'https://boards-api.greenhouse.io/v1/boards/Vestmark/jobs?content=true'

    export default {
        data() {
            return {
                api: this.getCareersApi(),
                careers: [],
                sortby: 'department',
                dataLoaded: false,
            }
        },
        mounted() {
            this.getCareers()
        },
        computed: {
            sortedCareers() {
                let compare = (a, b) => {

                    let aVal = ''
                    let bVal = ''

                    switch (this.sortby) {
                        case 'department':
                            aVal = a.departments[0].name
                            bVal = b.departments[0].name
                            break
                        case 'name':
                            aVal = a.title
                            bVal = b.title
                            break
                        case 'location':
                            aVal = a.location.name
                            bVal = b.location.name
                            break

                    }


                    if (aVal < bVal)
                        return -1;
                    if (aVal > bVal)
                        return 1;
                    return 0;
                }

                return this.careers.sort(compare);
            }
        },
        methods: {
            getCareers() {

                this.api.get('')
                    .then((response) => {
                        this.dataLoaded = true
                        this.careers = response.data.jobs
                        this.$nextTick(() => {
                          tables.initializeForVue()
                       })
                    })
            },
            getCareersApi() {
                return axios.create({
                    baseURL: apiBaseUrl
                })
            },
            getCareerHref(career) {
                return '/careers/' + career.id
            },
            sortCareers(by) {
                this.sortby = by
            }
        }
    }
</script>
